export const WARNING_COLOR = '#CF2125'
export const QB_PRIMARY_ONE_COLOR = '#00A0E3'
export const SEMI_BOLD = 600
export const QB_BLACK_COLOR = '#2d2d2d'
export const QB_BORDER_COLOR = '#CCCCCC'


// WEBPACK FOOTER //
// ./src/constants/style.js